<template>
  <PageLayout
    title="Terms of Service"
    subtitle="Please read these terms carefully before using our services. By engaging with Devolysis, you agree to these terms."
    :last-updated="content.lastUpdated"
    :show-c-t-a="true"
  >
    <div class="space-y-8">
      <LegalSection
        v-for="section in content.sections"
        :key="section.id"
        :title="section.title"
      >
        <div v-html="section.content"></div>
      </LegalSection>
    </div>
  </PageLayout>
</template>

<script setup>
import PageLayout from '@/components/layout/PageLayout.vue';
import LegalSection from '@/components/ui/LegalSection.vue';
import { termsContent } from '@/data/terms';

const content = termsContent;
</script>
